import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import LayoutsList from './LayoutsList/LayoutsList';

const FormLayouts = ({ match }) => {
    return (
        <div className="FormLayouts">
            <ContainerWrapper container="formLayouts">
                <Route exact path={match.path} component={LayoutsList} />
                <Route exact path={ `${ match.url }/edit/:formId` } component={LayoutsList} />
            </ContainerWrapper>
        </div>
    );
}

export default FormLayouts;
